module.exports = __webpack_public_path__ + "593a3d53/img/share-icon.0f8a11b4.svg";